import { styled } from '@mui/material/styles';

import { NAVIGATION_ITEM_VARIANT_MAP } from 'layout/MainLayout/components/Sidebar/constants';
import { NavigationItemStateKey } from 'layout/MainLayout/components/Sidebar/types';
import { ListItemText } from 'shared/components/ListItem';

import type { Theme } from '@mui/material';
import type {
  NavigationItemState,
  NavigationItem,
} from 'layout/MainLayout/components/Sidebar/types';

type NavigationItemTextState = NavigationItemState &
  Pick<NavigationItem, 'disabled' | 'sidebarType'>;

const getColor = (
  theme: Theme,
  { isActive, disabled, sidebarType }: NavigationItemTextState,
) => {
  if (isActive) {
    return theme.palette[NAVIGATION_ITEM_VARIANT_MAP[sidebarType]].main;
  }

  if (disabled) {
    return theme.palette.action.disabled;
  }

  return theme.palette.text.primary;
};

export const NavigationItemText = styled(ListItemText, {
  shouldForwardProp: prop =>
    prop !== NavigationItemStateKey.IsActive &&
    prop !== 'sidebarType' &&
    prop !== 'disabled',
})<NavigationItemTextState>(({ isActive, theme, disabled, sidebarType }) => ({
  ...theme.typography.body2,
  color: getColor(theme, { isActive, disabled, sidebarType }),
}));
